export default __webpack_public_path__ + "static/media/usda-logo-black.5e885625.png";